import { Typography, Row, Col } from "antd";

import "./index.css";

const { Text } = Typography;

const LoginFormContainer = ({ children }) => {
  return (
    <Row
      align="middle"
      justify="center"
      className="login-form-container center"
    >
      <Col xxl={6} sm={10}>
        {children}
        <Text type="secondary" className="small-font">
          Webová aplikace DHL
        </Text>
      </Col>
    </Row>
  );
};

export default LoginFormContainer;
